import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { ToastProvider } from '@phinest/ui';
import { AuthProvider } from '@/lib/auth';
import { QueryProvider } from '@/lib/query';
import { AppRoutes } from '@/routes';
import './index.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root is missing from index.html');

createRoot(el).render(
  <React.StrictMode>
    <QueryProvider>
      <ToastProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ToastProvider>
    </QueryProvider>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
